import React from 'react';
import { Archive, Files, Home, LayoutDashboard, ScanLine } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores/authStore';
import { useDepartmentsStore } from '../../stores/departmentsStore';
import { useUIStore } from '../../stores/uiStore';
import { ROUTES } from '../../config/routes';

export const BottomNav: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { can, user } = useAuthStore();
  const departments = useDepartmentsStore(state => state.departments);
  const openScanner = useUIStore(state => state.openScanner);
  const admin = can('admin.view');
  const workspace = departments.find(item => item.status === 'active' && user?.departments.includes(item.id));
  const workspaceRoute = workspace ? ROUTES.department(workspace.slug) : ROUTES.departments;

  return (
    <nav className="bottom-nav" aria-label={useUIStore.getState().lang === 'ar' ? 'التنقل الرئيسي' : 'Main navigation'}>
      <div className="bottom-nav-shell">
        <NavControl label={t('navigation.home')} icon={Home} active={location.pathname === ROUTES.home} onSelect={() => navigate(ROUTES.home)} />
        {admin
          ? <NavControl label={t('navigation.admin')} icon={LayoutDashboard} active={location.pathname === ROUTES.admin} onSelect={() => navigate(ROUTES.admin)} />
          : <NavControl label={t('navigation.documents')} icon={Files} active={workspace ? location.pathname === workspaceRoute : false} onSelect={() => navigate(workspaceRoute)} />}
        <button type="button" className="scanner-nav" onClick={openScanner} aria-label={t('navigation.scan')} data-nav-id="scanner"><ScanLine size={19} /><span aria-hidden="true">QR</span></button>
        <NavControl label={t('navigation.departments')} icon={Archive} active={location.pathname.startsWith(ROUTES.departments)} onSelect={() => navigate(ROUTES.departments)} />
      </div>
    </nav>
  );
};

const NavControl: React.FC<{ label: string; icon: LucideIcon; active: boolean; onSelect: () => void }> = ({ label, icon: Icon, active, onSelect }) => (
  <button type="button" className="nav-control" data-active={active} onClick={onSelect} aria-current={active ? 'page' : undefined}>
    <Icon size={19} />
    <span>{label}</span>
  </button>
);
